/**
 * Module constants matching the backend Module enum
 */
const Module = {
  QA_KNOWLEDGE_BASE: "qa_knowledge_base",
  STRUCTURED_DATA: "structured_data",
  ACRM: "acrm",
};

/**
 * Descriptions for each module to be displayed in the UI
 */
export const ModuleDescriptions = {
  [Module.QA_KNOWLEDGE_BASE]: "Enables the QA Knowledge Base tab for managing frequently asked questions and their answers. Use this for creating a knowledge base of common questions that can be used by the AI assistant.",
  [Module.STRUCTURED_DATA]: "Uses structured data instead of documents to retrieve doctors, schedules, and other information. This provides more accurate and up-to-date information.",
  [Module.ACRM]: "Agent CRM module (tailored)",
};

export default Module;
